//Library imports
import styled from 'styled-components';

const PersonalityPill = (props: any) => {
  const { title, personalityColor } = props;

  return (
    <Wrapper color={personalityColor} className={`${title} personality-pill`}>
      {title}
    </Wrapper>
  );
};

export default PersonalityPill;

PersonalityPill.defaultProps = {
  title: '',
  personalityColor: '',
};

const Wrapper = styled.div<{ color: string }>`
  background-color: ${(props) => props.color};
  color: #fff;
  font-family: 'Roboto';
  font-size: 9px;
  font-style: normal;
  font-weight: 500;
  line-height: 10px;
  letter-spacing: -0.3px;
  display: inline-flex;
  padding: 4px 10px;
  justify-content: center;
  align-items: center;
  border-radius: 16px;
  position: absolute;
  background-color: #979797;
  top: 5px;
  left: 10px;
  &.Dominant {
    background: #f5222d;
  }
  &.Influencer {
    background: #faad14;
  }
  &.Steady {
    background: #52c41a;
  }
  &.Conscientious {
    background: #1890ff;
  }
`;
